<script lang="ts">
	import GlassEffect from '#lib/modern/GlassEffect.svelte';
	import ModernGlassButton from '#lib/modern/ModernGlassButton.svelte';
	import Portal from '#lib/modern/Portal.svelte';
	import { answerConfirmation, confirmationState } from '#lib/stores/confirmation.js';
	import { t } from '#lib/stores/i18n.js';
	import { MessageCircleQuestionMark } from '@lucide/svelte';
	import { elasticOut } from 'svelte/easing';
	import { fade, scale } from 'svelte/transition';

	function handleKeydown(e: KeyboardEvent) {
		if ($confirmationState.show && e.key === 'Escape') {
			e.preventDefault();
			e.stopPropagation();
			answerConfirmation(false);
		}
	}
</script>

<svelte:window onkeydown={handleKeydown} />

{#if $confirmationState.show}
	<Portal>
		<div class="fixed inset-0 z-50 flex items-center justify-center p-4">
			<!-- Backdrop -->
			<div
				class="absolute inset-0 bg-secondary/80 dark:bg-secondary-dark/80 backdrop-blur-sm"
				transition:fade={{ duration: 200 }}
				role="presentation"
				onclick={(e) => {
					e.stopPropagation();
					answerConfirmation(false);
				}}
			></div>

			<!-- Modal Content -->
			<div
				class="relative z-10 w-full max-w-sm cursor-default"
				in:scale={{ duration: 600, start: 0.8, easing: elasticOut }}
				out:scale={{ duration: 200, start: 0.95 }}
				role="dialog"
				aria-modal="true"
				tabindex="-1"
				onclick={(e) => e.stopPropagation()}
				onkeydown={(e) => e.stopPropagation()}
			>
				<GlassEffect classContent="w-full max-w-sm" surfaceDesign>
					<div class="p-6 flex flex-col items-center text-center gap-4">
						<MessageCircleQuestionMark
							class="w-16 h-16 opacity-50 bg-primary text-primary-on p-4 rounded-full"
						/>

						<h3 class="text-xl font-bold text-surface-on dark:text-surface-dark-on">
							{$confirmationState.title || $t('modal.are_you_sure')}
						</h3>

						<p class="text-surface-on/80 dark:text-surface-dark-on/80">
							{$confirmationState.message}
						</p>

						<div class="flex gap-3 w-full mt-2">
							<div class="w-full">
								<ModernGlassButton
									title={$t('modal.cancel')}
									onclick={() => answerConfirmation(false)}
									color="secondary"
									className="justify-center"
								/>
							</div>
							<div class="w-full">
								<ModernGlassButton
									title={$t('modal.confirm')}
									onclick={() => answerConfirmation(true)}
									color="primary"
									className="justify-center"
								/>
							</div>
						</div>
					</div>
				</GlassEffect>
			</div>
		</div>
	</Portal>
{/if}
